import { lazy, ComponentType } from 'react';

// Key por módulo para não bloquear retry de outros widgets
function getRetryKey(importFn: () => Promise<unknown>): string {
  return `chunk-retry:${importFn.toString().slice(0, 100)}`;
}

function isChunkError(error: unknown): boolean {
  const msg = error instanceof Error ? error.message : String(error);
  return (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('Unable to preload CSS') ||
    msg.includes('Load failed')
  );
}

export function lazyWithRetry<T extends ComponentType<any>>(
  importFn: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    const retryKey = getRetryKey(importFn);
    const hasRetried = sessionStorage.getItem(retryKey);

    try {
      const module = await importFn();
      sessionStorage.removeItem(retryKey);
      return module;
    } catch (error) {
      if (isChunkError(error) && !hasRetried) {
        sessionStorage.setItem(retryKey, '1');
        // Força buscar chunk novo do servidor (ignora cache do browser)
        window.location.reload();
        // Se a recarga foi cancelada (pergunta "sair do site?"), cai na tela de
        // erro da rota em vez de ficar presa no carregador para sempre
        return new Promise<never>((_, reject) => {
          window.setTimeout(() => reject(error), 10000);
        });
      }
      throw error;
    }
  });
}
